import { Link } from "react-router-dom";
import { Leaf, ArrowLeft, Mail, Clock } from "lucide-react";
import Footer from "@/components/Footer";

const Contact = () => {
  return (
    <div className="min-h-screen bg-[#F8F6F1] flex flex-col" data-testid="contact-page">
      {/* Nav */}
      <nav className="sticky top-0 z-50 bg-[#F8F6F1]/80 backdrop-blur-xl border-b border-[#D4C9B8]/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#9FB89F] to-[#7A9B7E] flex items-center justify-center">
              <Leaf className="w-4 h-4 text-white" />
            </div>
            <span className="font-serif text-xl font-medium text-[#2D3A2D]">My Story</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 font-sans text-sm text-[#7A8A7A] hover:text-[#2D3A2D] transition-colors" data-testid="contact-back-home">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#2D3A2D] mb-3 tracking-tight" data-testid="contact-title">
          Contact Us
        </h1>
        <p className="font-sans text-sm text-[#7A8A7A] mb-10">We're here to help you preserve your memories.</p>

        <div className="prose-custom space-y-8">
          <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
            If you have any questions, require support with an order, or need technical assistance, please reach out to us.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Email card */}
            <div className="bg-white/60 backdrop-blur-sm border border-[#D4C9B8]/40 rounded-2xl p-8" data-testid="contact-email-card">
              <div className="w-12 h-12 rounded-full bg-[#9FB89F]/20 flex items-center justify-center mb-5">
                <Mail className="w-5 h-5 text-[#7A9B7E]" />
              </div>
              <h3 className="font-serif text-lg font-medium text-[#2D3A2D] mb-2">Email</h3>
              <a href="mailto:neginder7@gmail.com" className="font-sans text-base text-[#7A9B7E] hover:text-[#4A5D4A] transition-colors break-all">
                neginder7@gmail.com
              </a>
            </div>

            {/* Hours card */}
            <div className="bg-white/60 backdrop-blur-sm border border-[#D4C9B8]/40 rounded-2xl p-8" data-testid="contact-hours-card">
              <div className="w-12 h-12 rounded-full bg-[#9FB89F]/20 flex items-center justify-center mb-5">
                <Clock className="w-5 h-5 text-[#7A9B7E]" />
              </div>
              <h3 className="font-serif text-lg font-medium text-[#2D3A2D] mb-2">Operating Hours</h3>
              <p className="font-sans text-base text-[#4A5D4A]">Monday to Friday</p>
              <p className="font-sans text-base text-[#4A5D4A]">9:00 AM – 6:00 PM (IST)</p>
            </div>
          </div>

          <div className="bg-[#9FB89F]/10 border border-[#9FB89F]/20 rounded-xl p-6 mt-4">
            <p className="font-sans text-sm text-[#4A5D4A] leading-relaxed">
              We aim to respond to all queries within <strong className="text-[#2D3A2D]">24 to 48 hours</strong>.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
